
import { Box, Grid, IconButton, Link, Typography, useTheme, Tooltip } from "@mui/material";
import Modal from "../../Modal";
import { Close } from "@mui/icons-material";
import { ReactComponent as SendTg } from '../../../../assets/icons/icon_send_tg.svg'
import { ReactComponent as SendMax } from '../../../../assets/icons/icon_send_max.svg'
import { ReactComponent as Knowledge } from '../../../../assets/icons/icon_knowledge.svg'

function ModalSupport({ open, onClose }) {
  const theme = useTheme()

  return(
    <Modal open={open} onClose={onClose} sxContent={{ width: { xs: '95%', md: '34rem' },  borderRadius: '20px' }}>
      <Box p={{ xs: 2.5, md: 3.5 }}>
        <Grid container>
          <Grid item container alignItems='center' justifyContent='flex-end'>
            <Tooltip title='Закрыть' placement="top">
              <IconButton onClick={onClose}>
                <Close />
              </IconButton>
            </Tooltip>
          </Grid>

        <Grid item sx={{ display: 'flex' }} gap={4}>
          <Grid container item sx={{ flexDirection: 'column', gap: 5 }}>
            <Typography sx={{ fontSize: '28px', fontWeight: 500, lineHeight: 1 }}>Служба поддержки</Typography>
            
            <Grid sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
              <a href='https://telegram.me/D24_support' target='_blank' rel='noreferrer' style={{ textDecoration: 'none', color: 'inherit' }}>
                <Grid sx={{ display: 'flex', gap: 1.5 }}>
                  <SendTg style={{ cursor: 'default', width: '22px', height: '22px' }} />
                  <Typography sx={{ fontSize: 16, transition: '0.2s ease', cursor: 'pointer', '&:hover': { color: theme.palette.OICO.purple } }}>
                    Написать в Telegram
                  </Typography>
                </Grid>
              </a>
                
              <a href='https://max.ru/u/f9LHodD0cOLFFCrb9P3asMcZKKVSqbXRk2_AIAGUo7dAn0uDrz39NPT8L38' target='_blank' rel='noreferrer' style={{ textDecoration: 'none', color: 'inherit' }}>
                <Grid sx={{ display: 'flex', gap: 1.5 }}>
                  <SendMax style={{ cursor: 'default', width: '22px', height: '22px' }} />
                  <Typography sx={{ fontSize: 16, transition: '0.2s ease', cursor: 'pointer', '&:hover': { color: theme.palette.OICO.purple } }}>
                    Написать в Max
                  </Typography>
                </Grid>
              </a>

              <a href="https://help.ds24.ru" target='_blank' rel='noreferrer' style={{ textDecoration: 'none', color: 'inherit' }}>
                <Grid sx={{ display: 'flex', gap: 1.5 }}>
                  <Knowledge style={{ cursor: 'default', width: '22px', height: '22px' }} />
                  <Typography sx={{ fontSize: 16, transition: '0.2s ease', cursor: 'pointer', '&:hover': { color: theme.palette.OICO.purple } }}>
                    База знаний
                  </Typography>
                </Grid>
              </a>

            </Grid>
          </Grid>
          
        </Grid>
        </Grid> 

        <Grid sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, pt: 6 }}>
          <Grid sx={{ display: 'flex', gap: 1.5 }}>
            <Typography fontSize={14} sx={{ color: theme.palette.grey.main }}>Телефон:</Typography>
            <Typography fontSize={14}>8 800 100 47 75</Typography>
          </Grid>
          <Grid sx={{ display: 'flex', gap: 1.5, alignItems: 'center' }}>
            <Typography fontSize={14} sx={{ color: theme.palette.grey.main }}>Почта:</Typography>
            <Link href="mailto:sos@ds24.ru" underline="none" sx={{ color: theme.palette.text.link }}>
              sos@ds24.ru
            </Link>     
          </Grid>
        </Grid>

      </Box>
    </Modal>
  )
}

export default ModalSupport;